import { ButtonBase, Stack, Typography } from '@mui/material'
import React from 'react'
import type { AccessCell } from './accessMatrix'
import { CellStatus, featureLabel } from './accessMatrix'
import EntitlementStatusChip from './EntitlementStatusChip'

type Props = {
  cell?: AccessCell
  onEdit: (cell: AccessCell) => void
}

const EntitlementCell: React.FC<Props> = ({ cell, onEdit }) => {
  if (!cell) return null

  if (cell.status === CellStatus.NotApplicable)
    return (
      <Typography variant="caption" color="text.secondary">
        {cell.reason}
      </Typography>
    )

  return (
    <ButtonBase
      onClick={() => onEdit(cell)}
      sx={{ borderRadius: 1, p: 1, m: -1, justifyContent: 'flex-start', textAlign: 'left' }}
      aria-label={[
        `${cell.scope.title}, ${featureLabel[cell.scope.feature]}: ${cell.status}`,
        cell.reason,
        cell.usageWarning,
      ]
        .filter(Boolean)
        .join('. ')}
    >
      <Stack spacing={0.5} alignItems="flex-start">
        <EntitlementStatusChip status={cell.status} />
        <Typography variant="caption" color="text.secondary">
          {cell.reason}
        </Typography>
        {cell.usageWarning && (
          <Typography variant="caption" color="warning.dark">
            {cell.usageWarning}
          </Typography>
        )}
      </Stack>
    </ButtonBase>
  )
}

export default EntitlementCell
